import StorageService from "service/storage/StorageService";
import Config from "./EnvironmentConfig";

class EnvironmentService {
  constructor(environment) {
    this.storageService = new StorageService();
    this.config = Config;

    if (window.location.hostname === "expert.zyla.in") {
      this.environment = this.storageService.get("ENVIRONMENT") || "production";
    } else {
      this.environment =
        this.storageService.get("ENVIRONMENT") || "development";
    }
  }

  get() {
    return this.environment;
  }

  set(environment) {
    this.environment = environment;
    this.storageService.set("ENVIRONMENT", this.environment);
  }

  isProduction() {
    return this.environment === this.config.environments.production;
  }

  getBaseAPI() {
    return this.config.vars[this.environment].apiUrl;
  }

  getServiceAPI() {
    return this.config.vars[this.environment].serviceUrl;
  }
  // Chief-complaints v2 backend (api-cc-v2-service). Only phr talks to it — kept
  // separate from serviceUrl because it will migrate off localhost once deployed.
  getCcV2API() {
    return this.config.vars[this.environment].ccV2Url;
  }
  // Diagnosis v2 backend (api-diagnosis-v2-service). Same rationale as ccV2.
  getDiagnosisV2API() {
    return this.config.vars[this.environment].diagnosisV2Url;
  }
  // Medicine v2 backend (api-medicine-v2-service). Same rationale as ccV2.
  getMedicineV2API() {
    return this.config.vars[this.environment].medicineV2Url;
  }
  // Addiction v2 backend (api-addiction-v2-service). Same rationale as ccV2.
  getAddictionV2API() {
    return this.config.vars[this.environment].addictionV2Url;
  }
  // Family History v2 backend (api-family-history-v2-service). Same rationale as ccV2.
  getFamilyHistoryV2API() {
    return this.config.vars[this.environment].familyHistoryV2Url;
  }
  // Physical Activity v2 backend (api-activity-v2-service). Same rationale as ccV2.
  getActivityV2API() {
    return this.config.vars[this.environment].activityV2Url;
  }
  // Allergy v2 backend (api-allergy-v2-service). Same rationale as ccV2.
  getAllergyV2API() {
    return this.config.vars[this.environment].allergyV2Url;
  }
  // Hospitalisation v2 backend (api-hospitalisation-v2-service). Same rationale as ccV2.
  getHospitalisationV2API() {
    return this.config.vars[this.environment].hospitalisationV2Url;
  }
  // Lab investigation v2 backend (api-lab-investigation-v2-service). Same rationale as ccV2.
  getLabInvestigationV2API() {
    return this.config.vars[this.environment].labInvestigationV2Url;
  }
  // Anthropometric v2 backend (api-anthropometric-v2-service). Same rationale as ccV2.
  getAnthropometricV2API() {
    return this.config.vars[this.environment].anthropometricV2Url;
  }
  // Food preferences v2 backend (api-food-preferences-v2-service). Same rationale as ccV2.
  getFoodPreferencesV2API() {
    return this.config.vars[this.environment].foodPreferencesV2Url;
  }
  // Daily schedule v2 backend (api-daily-schedule-v2-service). Same rationale as ccV2.
  getDailyScheduleV2API() {
    return this.config.vars[this.environment].dailyScheduleV2Url;
  }
  // AI transcript v2 backend (api-ai-transcript-v2-service). Same rationale as ccV2.
  getAiTranscriptV2API() {
    return this.config.vars[this.environment].aiTranscriptV2Url;
  }
  getServiceAPINew() {
    return this.config.vars[this.environment].serviceNew;
  }

  getServiceSocket() {
    return this.config.vars[this.environment].serviceSocket;
  }

  getDomain() {
    return this.config.vars[this.environment].domain;
  }

  getLocalService() {
    return this.config.vars[this.environment].localService;
  }
  strapiUrl() {
    return this.config.vars[this.environment].strapiUrl;
  }
}

export default EnvironmentService;
